import { FormattedMessage } from 'react-intl';
import { Grid, Typography, Stack } from 'components/ui';
import { GrayCard } from 'components/styles_components/card';
import { CardOptionTypography, CardOptionHintTypography } from 'components/styles_components/typography';
import Result from 'components/inspection/result';
import Date from 'components/date';

const ResultCard = ({ result, doneAt }) => (
  <Grid size={{ xs: 6, lg: 3 }}>
    <GrayCard>
      <Stack>
        <CardOptionTypography>
          <FormattedMessage id="inspection.result" />
        </CardOptionTypography>
        <Typography component="span">
          <Result result={result} />
        </Typography>
        {doneAt && (
          <CardOptionHintTypography>
             <Date date={doneAt} />
          </CardOptionHintTypography>
        )}
      </Stack>
    </GrayCard>
  </Grid>
);

export default ResultCard;
